import script from "./audio-player.vue?vue&type=script&setup=true&lang=js"
export * from "./audio-player.vue?vue&type=script&setup=true&lang=js"

import "./audio-player.vue?vue&type=style&index=0&id=6afc99fb&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afc99fb"]])

export default __exports__